<script>
	import { pageOffset, isPortraitScreen } from '../../js/model/stores';
	import { animateElement } from '../../js/utils/animate';

	let _duck;
	let inView = false;
	let start = 0;
	let scrollDirectionDown = true;
	let scrolledBefore = 0;
	let portrait;

	export let direction;
	export let speedMultiplier;

	let animation = (value) => {
		animateElement(value, _duck.parentElement, (currentPageOffset) => {
			if (!inView) {
				start = currentPageOffset;
				inView = true;
			}
			scrollDirectionDown = scrolledBefore < currentPageOffset;
			scrolledBefore = currentPageOffset;
			const elmentInViewPercentage = (currentPageOffset - start) * 100 / window.innerHeight;

			_duck.querySelector('svg').style.transform = `translateX(${direction === 'ltr' ? '' : '-'}${Math.min(80, elmentInViewPercentage * 0.5 * speedMultiplier)}vw) scaleX(${scrollDirectionDown ? '1' : '-1'})`;
		});
	};

	function getOffsetTop(element) {
		if (element.offsetParent) {
			return element.offsetTop + getOffsetTop(element.offsetParent);
		}
		return element.offsetTop || 0;
	}


	let prepareScene = () => {
		if (!_duck) {
			requestAnimationFrame(prepareScene);
			return;
		}

		isPortraitScreen.subscribe((state) => {
			portrait = state;
		});
		pageOffset.subscribe(animation);
	};

	prepareScene();

</script>

<style>
	div {
		position: relative;
	}
</style>

<div class:portrait bind:this={_duck}>
<slot></slot>
</div>
